module.exports = __webpack_public_path__ + "img/maneken_pos_8.bf7054b4.png";